export default __webpack_public_path__ + "static/media/Mark-5-HUD-Targeting (Reticle).74de5326.jpg";